import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { AvatarDirective } from 'src/app/common/avatar/avatar.directive';
import { IconComponent } from 'src/app/common/icon/icon.component';
import { SearchOptionKind } from '../search-bar.models';
import { SearchBarStore } from '../search-bar.store';
import { optionId } from '../search-input.directive';

const KIND_ICONS: Record<SearchOptionKind, string> = {
  place: 'map-pin',
  hashtag: 'hash',
  content: 'image',
  all: 'magnifying-glass',
};

@Component({
  selector: 'sharry-search-results',
  standalone: true,
  imports: [RouterLink, I18NextModule, IconComponent, AvatarDirective],
  templateUrl: './search-results.component.html',
  styleUrl: './search-results.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultsComponent {
  readonly store = inject(SearchBarStore);
  readonly listboxId = input.required<string>();

  readonly icons = KIND_ICONS;
  readonly placeholder = 'https://media.sharry.land/app/images/img-meraviglie_vicino.svg';
  readonly optionId = optionId;
  readonly skeletonRows = [0, 1, 2];
}
